<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>盘点记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="checkStockRequest.selectDate"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      size="mini"
      @change="queryCheckStock"
    >
    </el-date-picker>
      <el-table height="550px" :data="checkStockList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          prop="checkDate"
          label="盘点日期"
          align="center">
        </el-table-column>
        <el-table-column
          prop="productTypeName"
          label="产品分类名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="productName"
          label="产品名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="num"
          label="盘点数量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createName"
          label="盘点人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="comment"
          label="备注说明"
          align="center">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      authorities:'',
      userId:'',
      checkStockList:[],
      queryText:'',
      checkStockRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:''
      },

      currentPage: 1,
      pageSize:20,
      pageTotal:0
    }
  },
  methods:{
    queryCheckStock(){
      if (this.checkStockRequest.selectDate !== ''){
        this.checkStockRequest.startDate = this.checkStockRequest.selectDate[0];
        this.checkStockRequest.endDate = this.checkStockRequest.selectDate[1];
      }
      this.loadCheckStock();
    },
    async loadCheckStock(){
      this.checkStockRequest.orgId = this.currentOrgId;
      this.checkStockRequest.pageNum = this.currentPage;
      this.checkStockRequest.pageSize = this.pageSize;
      const {data:res} = await this.$http.post(`/checkStock/getData`, this.checkStockRequest)
      if (res.code !== 200){
        return this.$message.error("获取盘点信息失败！")
      }
      this.checkStockList = res.data.list;
      this.pageTotal = res.data.total;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadCheckStock();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCheckStock();
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadCheckStock();
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
  text-align: center !important;
}
/deep/ td {
  padding: 2px ;
}
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
.el-dialog__title{
  color: #ffffff;
}
.el-dialog__close{
  color: #ffffff !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/CheckStock.vue